module.exports = __webpack_public_path__ + "static/media/logo.c1128a55.svg";